import CircleCI from './CircleCI'

export default CircleCI
